/* SAF Hero Slider — paging slider, vanilla JS. Autoplay, swipe, dots, arrows, a11y. */
(function () {
  'use strict';

  function initSlider(root) {
    if (root._safHsInit) return;
    root._safHsInit = true;

    var track = root.querySelector('[data-hs-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hs-slide]'));
    var dotsWrap = root.querySelector('[data-hs-dots]');
    var prev = root.querySelector('[data-hs-prev]');
    var next = root.querySelector('[data-hs-next]');
    var controls = root.querySelector('[data-hs-controls]');
    var count = slides.length;

    if (count <= 1) {
      if (controls) controls.style.display = 'none';
      if (dotsWrap) dotsWrap.style.display = 'none';
      return;
    }

    var index = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 6000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;

    var dots = [];
    if (dotsWrap) {
      slides.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'saf-hslider__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.addEventListener('click', function () { go(i, true); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    function update() {
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      slides.forEach(function (s, i) { s.setAttribute('aria-hidden', i === index ? 'false' : 'true'); });
      dots.forEach(function (d, i) {
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
        d.classList.toggle('is-active', i === index);
      });
    }
    function go(i, user) { index = (i + count) % count; update(); if (user) restart(); }

    if (next) next.addEventListener('click', function () { go(index + 1, true); });
    if (prev) prev.addEventListener('click', function () { go(index - 1, true); });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(index + 1, true); }
      else if (e.key === 'ArrowLeft') { go(index - 1, true); }
    });

    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1), true); } else { start(); }
      startX = null;
    }, { passive: true });

    function start() { if (autoplay && !reduce && !timer && count > 1) { timer = setInterval(function () { go(index + 1); }, speed); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    update();
    start();
  }

  function init() { document.querySelectorAll('[data-saf-hero-slider]').forEach(initSlider); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
